import angular from "angular";

import LandingPageHeaderComponent from "./landing-page-header/landing-page-header.component";
import LandingPageHeaderLinkComponent from "./landing-page-header-link/landing-page-header-link.component";
import LandingPageHeaderItemComponent from "./landing-page-header-item/landing-page-header-item.component";
import LandingPageSection from "./landing-page-section/landing-page-section.component";
import LandingPageSectionContent from "./landing-page-section-content/landing-page-section-content.component";
import LandingPageServiceList from "./landing-page-service-list/landing-page-service-list.component";
import LandingPageCarousel from "./landing-page-carousel/landing-page-carousel.component";
import LandingPageCarouselItem from "./landing-page-carousel-item/landing-page-carousel-item.component";
import LandingPageInfoMessage from "./landing-page-info-message/landing-page-info-message.component";
import LandingPageArrowedList from "./landing-page-arrowed-list/landing-page-arrowed-list.component";
import LandingPageArrowedListItem from "./landing-page-arrowed-list-item/landing-page-arrowed-list-item.component";
import LandingPageScrollingList from "./landing-page-scrolling-list/landing-page-scrolling-list.component";
import LandingPageDescBlock from "./landing-page-desc-block/landing-page-desc-block.component";
import LandingPageSteps from "./landing-page-steps/landing-page-steps.component";
import LandingPageStepsItem from "./landing-page-steps-item/landing-page-steps-item.component";
import LandingPageAccordion from "./landing-page-accordion/landing-page-accordion.component";
import LandingPageAccordionItem from "./landing-page-accordion-item/landing-page-accordion-item.component";
import LandingPageMainBlock from "./landing-page-main-block/landing-page-main-block.component";
import LandingPageVtLogo from "./landing-page-vt-logo/landing-page-vt-logo.component";

import ServicesPublicApi from "../../resources/services/public-services.resource";

export default angular.module("vt-public-landing-page.module", [
    ServicesPublicApi.name
])
    .component("landingPageHeader", LandingPageHeaderComponent)
    .component("landingPageHeaderLink", LandingPageHeaderLinkComponent)
    .component("landingPageHeaderItem", LandingPageHeaderItemComponent)
    .component("landingPageSection", LandingPageSection)
    .component("landingPageSectionContent", LandingPageSectionContent)
    .component("landingPageServiceList", LandingPageServiceList)
    .component("landingPageCarousel", LandingPageCarousel)
    .directive("landingPageCarouselItem", LandingPageCarouselItem)
    .component("landingPageInfoMessage", LandingPageInfoMessage)
    .component("landingPageArrowedList", LandingPageArrowedList)
    .component("landingPageArrowedListItem", LandingPageArrowedListItem)
    .component("landingPageScrollingList", LandingPageScrollingList)
    .component("landingPageDescBlock", LandingPageDescBlock)
    .component("landingPageSteps", LandingPageSteps)
    .component("landingPageStepsItem", LandingPageStepsItem)
    .component("landingPageAccordion", LandingPageAccordion)
    .component("landingPageAccordionItem", LandingPageAccordionItem)
    .component("landingPageMainBlock", LandingPageMainBlock)
    .component("landingPageVtLogo", LandingPageVtLogo);
